import React, {useEffect, useState} from 'react'
import { collection, doc, getDocs, query, where, setDoc, updateDoc, deleteDoc, deleteField} from "firebase/firestore"; 
import { db } from "../firebase-config";
import { Link } from 'react-router-dom';

export default function Display() {

    const [confirmed, setConfirmed] = useState([])
    const [orientation, setOrientation] = useState([])


    const loadConfirmedData = async () =>  {
        setConfirmed([]);
        const ref = query(collection(db, 'inscriptions', 'exposants', '2024', 'type', 'confirmés'), where("ACTIVITIES", "array-contains", "Orientation"));
        const querySnapshot = await getDocs(ref)
        querySnapshot.forEach((doc) => {
          console.log(doc.id);
          setConfirmed(confirmed => [doc.data(), ...confirmed])
        }) 

      
       
      }

      
      useEffect(() => {
        loadConfirmedData()
     
      }, [])


      useEffect(() => {
        if(confirmed.length > 0) {
            setOrientation([])
            confirmed.map(item => {
                console.log(item.URL.startsWith('https://'));
                if(item.URL.length > 0 ) {

                    if(item.URL.startsWith('http')) {
                        setOrientation(orientation => [{
                            ENTREPRISE: item.ENTREPRISE,
                            ID: item.ID,
                            LOGO: item.LOGO,
                            ACTIVITIES: item.ACTIVITIES,
                            URL: `https://${item.URL}`,
                            TEXT: item.URL.replace('https://', '').replace('www.', '').replace('http://', ''),
                            Date: item.Date
                        }, ...orientation])
                        
                        
                    } else {
                        setOrientation(orientation => [{
                            ENTREPRISE: item.ENTREPRISE,
                            ID: item.ID,
                            LOGO: item.LOGO,
                            ACTIVITIES: item.ACTIVITIES,
                            URL: `https://${item.URL}`,
                            TEXT: item.URL.replace('https://', '').replace('www.', '').replace('http://', ''),
                            Date: item.Date
                        }, ...orientation])
                        
                }
                console.log(orientation);
                
            } else {
                setOrientation(orientation => [{
                    ENTREPRISE: item.ENTREPRISE,
                    ID: item.ID,
                    LOGO: item.LOGO,
                    ACTIVITIES: item.ACTIVITIES,
                    URL: `https://${item.URL}`,
                    TEXT: item.URL.replace('https://', '').replace('www.', '').replace('http://', ''),
                    Date: item.Date
                }, ...orientation])
            }
        })  
      }
    }, [confirmed])

  console.log(confirmed);
  

  return (
    <div>
      <div className="wrapper">
      
        <div className="orientation">
        {orientation.sort((a, b) => a.ENTREPRISE.localeCompare(b.ENTREPRISE)).map(item => {
            return (
                <div className="box" key={item.ID}>
                    <div className="info">
                        <h3>{item.ENTREPRISE}</h3>
                        <h4><a href={item.URL} target='_blank'>{item.TEXT.toLowerCase()}</a></h4>
                    </div>
                    {item.LOGO &&
                    <div className="logo">
                        <img src={item.LOGO} alt="" />
                    </div>
                    }
                </div>
            )
        })}
        </div>
     </div>
    </div>
  )
}
